module.exports = __webpack_public_path__ + "img/illu-leaf.d5178c30.svg";